import { PlatformEnum } from '@vacationtracker/shared/data/platforms'

import { track } from '../../../services/analytics/analytics'
import { AUTH_FLOW } from '../../../services/analytics/auth-events'

type SigninEventPayload = { [key: string]: string | string[] | number | boolean | undefined | null }

/**
 * The address being signed in with, stamped onto every event the way the sign-up flow does
 * it. Held on the module because most events are reported from hooks that never see the
 * address: a platform failure knows the platform and nothing else.
 */
let signinEmail: string | undefined

export const setSigninEmail = (email?: string | null): void => {
  signinEmail = email ? email.toLowerCase() : undefined
}

/**
 * Every event carries the flow, so the two sign-in pages stay separable in reporting, and
 * the address once there is one. An explicit payload value wins over the stamped address.
 */
export const trackSignin = (eventName: string, payload: SigninEventPayload = {}): Promise<void> => track(eventName, { email: signinEmail, ...payload, authFlow: AUTH_FLOW })

export const trackLoginStarted = (platform: string, payload: SigninEventPayload = {}): void => {
  trackSignin('LOGIN_STARTED', {
    platform,
    ...payload,
    timestamp: new Date().toISOString(),
    source: 'app',
    status: 'started',
  })
}

export const trackLoginCompleted = (payload: SigninEventPayload): void => {
  trackSignin('LOGIN_COMPLETED', {
    ...payload,
    timestamp: new Date().toDateString(),
    source: 'app',
    status: 'completed',
  })
}

/**
 * The closing step of each per-platform funnel, next to the LOGIN_COMPLETED the dashboards read.
 * Kept in this folder rather than a shared module so sign-in and sign-up stay independent.
 */
export const SIGNIN_SUCCESS_EVENT: Record<string, string> = {
  [PlatformEnum.Slack]: 'SIGN_IN_WITH_SLACK_SUCCESS',
  [PlatformEnum.Microsoft]: 'SIGN_IN_WITH_MICROSOFT_SUCCESS',
  [PlatformEnum.Google]: 'SIGN_IN_WITH_GOOGLE_SUCCESS',
  [PlatformEnum.Email]: 'SIGN_IN_WITH_EMAIL_SUCCESS',
  adp: 'SIGN_IN_WITH_ADP_SUCCESS',
}
